import React, { useState } from 'react';
import { styled } from '@this/constants/themes';
import { observer } from 'mobx-react';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import ApproveItem from '@this/domain/approve_item/approve_item';
import {
  OrganizationBody,
  OrganizationTitle,
  OrganizationNavBar
} from '@this/components/organization/organization.style';
import { Fetcher, HTTPError } from '@this/src/util';
import ApproveItemForm from './approve_item_form';
import { Loading } from '../../shared/ui/feedbacks/loading';
import { Button } from '../../shared/ui/inputs/button';
import { Link } from '../../shared/ui/navigations/link';

const fetchConnectionErrorMessage = '通信環境が不安定です。\n時間をおいてもう一度お試しください。';

type Props = {
  showExicSeisanTrips: boolean;
};

const ApproveItemNew = observer(({ showExicSeisanTrips }: Props) => {
  const [approveItem] = useState<ApproveItem>(new ApproveItem({} as any));
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);
  const [submitMessage, setSubmitMessage] = useState<string | null>(null);

  const handleSubmit = async (fe: React.FormEvent) => {
    fe.preventDefault();
    setSaving(true);
    setErrors([]);
    let message = '';
    try {
      const params = approveItem.submitParams();
      await Fetcher.post(`/organization/approve_items`, params);
      message = '保存しました';
      location.href = '/organization/approve_items';
    } catch (e) {
      const submitErrors =
        e instanceof HTTPError && e.response?.data.errors
          ? Array.isArray(e.response.data.errors)
            ? e.response.data.errors
            : [e.response.data.errors]
          : [fetchConnectionErrorMessage];
      message = submitErrors.join('\n');
      setErrors(submitErrors);
      if (!(e instanceof HTTPError && e.response?.data.errors)) {
        utils.sendErrorObject(e);
      }
    } finally {
      setSubmitMessage(message);
      setSaving(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSubmitMessage(null);
  };

  return (
    <>
      <Snackbar
        open={!!submitMessage}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert onClose={handleCloseSnackbar} severity={errors.length ? 'error' : 'success'}>
          {submitMessage && submitMessage.split('\n').map((line, i) => <div key={i}>{line}</div>)}
        </MuiAlert>
      </Snackbar>
      <OrganizationNavBar>
        <Link href="/organization/approve_items" style={{ display: 'flex', alignItems: 'center' }}>
          <ChevronLeft />
          申請項目に戻る
        </Link>
      </OrganizationNavBar>
      <OrganizationTitle>申請項目情報を追加する</OrganizationTitle>
      <OrganizationBody>
        <Wrap>
          {approveItem ? (
            <form onSubmit={handleSubmit}>
              <ApproveItemForm approveItem={approveItem} showExicSeisanTrips={showExicSeisanTrips} />
              <div className="flex">
                <Button
                  type="reset"
                  color="sub"
                  href="/organization/approve_items"
                  disabled={saving}
                  style={{ marginRight: '10px' }}
                >
                  キャンセル
                </Button>
                <Button type="submit" color="primary" disabled={saving}>
                  保存
                </Button>
              </div>
              {saving && <Loading />}
            </form>
          ) : (
            <Loading />
          )}
        </Wrap>
      </OrganizationBody>
    </>
  );
});

const Wrap = styled.div`
  padding: 10px;
`;

export default ApproveItemNew;
